import grantsInfo from "../../api/grants.json";
import { ListOfEvents } from "../ListOfEvents/ListOfEvents";

export const Grants = () => {
	const grantsData = grantsInfo.map((grant) => ({
		id: grant.grantId,
		year: grant.grantYear,
		info: grant.grantInfo,
		infoSecond: grant.grantInfoSecond,
	}));
	return (
		<section className="container grants">
			<ListOfEvents events={grantsData} />
		</section>
	);
};
